import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, apiError } from "../../lib/api";
import { MiniMarkdown } from "../emmy/MiniMarkdown";

const dt = (s) => (s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "");

export function EmmyConversations() {
  const [rows, setRows] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => { api.get("/admin/emmy/conversations").then(({ data }) => { setRows(data); setSel(data[0] || null); }).catch((e) => { setRows([]); console.error(apiError(e)); }); }, []);
  if (!rows) return <div className="flex justify-center py-10"><Loader2 className="animate-spin text-ciel" /></div>;
  return (
    <div data-testid="emmy-conversations">
      <h2 className="font-display text-lg font-bold text-navy">Conversations Emmy</h2>
      <p className="text-xs text-slate-500">{rows.length} conversation{rows.length > 1 ? "s" : ""} avec l'agent support IA.</p>
      {rows.length === 0 ? <p className="mt-6 text-sm text-slate-500" data-testid="emmy-conv-empty">Aucune conversation pour le moment.</p> : (
        <div className="mt-4 grid gap-4 lg:grid-cols-[300px_1fr]">
          <ul className="max-h-[560px] space-y-2 overflow-y-auto">
            {rows.map((r) => {
              const first = (r.messages || []).find((m) => m.role === "user");
              return (
                <li key={r.session_id}>
                  <button onClick={() => setSel(r)} data-testid={`emmy-conv-${r.session_id}`}
                    className={`w-full rounded-xl px-3 py-2 text-left text-sm transition-colors ${sel?.session_id === r.session_id ? "bg-[#0369A1] text-white" : "bg-[#E0F2FE] text-[#0C4A6E] hover:bg-[#BAE6FD]"}`}>
                    <p className="truncate font-semibold">{first?.content || "—"}</p>
                    <p className="text-[11px] opacity-80">{dt(r.updated_at)} · {r.nb_messages} messages</p>
                  </button>
                </li>
              );
            })}
          </ul>
          {sel && (
            <div className="max-h-[560px] space-y-3 overflow-y-auto rounded-2xl border border-[#7DC4E8] bg-[#F0F9FF] p-4" data-testid="emmy-conv-detail">
              {(sel.messages || []).map((m, i) => (
                <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${m.role === "user" ? "bg-[#0369A1] text-white" : "border border-[#BAE6FD] bg-white text-slate-700"}`}>
                    {m.role === "user" ? m.content : <MiniMarkdown text={m.content} />}
                    <p className={`mt-1 text-[10px] ${m.role === "user" ? "text-sky-100" : "text-slate-400"}`}>{dt(m.at)}{m.page ? ` · ${m.page}` : ""}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
